import React from 'react';

import { ScoreBoardAccordion } from '@/components/scoreboard/ScoreBoardAccordion';
import { useScoreboard } from '@/components/scoreboard/use-scoreboard';
import { useGameTrackerConfig } from '@/hooks/use-game-tracker-config';
import { useEventStatus } from '@/hooks/use-sbk-event-details-cache';
import { getEventTeamLogos } from '@/utils/team-logo-colors';

import { BetEvent } from '../hooks/types';
import { useEventTitle } from '../hooks/use-event-title';
import { BetSelectionList } from './bet-selections/BetSelectionList';

type EventGroupingItemProps = {
    event: BetEvent;
    isLastEvent: boolean;
    showGameTrackerTooltip?: boolean;
};

export const EventGroupingItem = ({ event, isLastEvent, showGameTrackerTooltip }: EventGroupingItemProps) => {
    const eventStatus = useEventStatus(event.id) ?? event.status;
    const eventTitle = useEventTitle(event);
    const { teamLogos, teamFallbackTextColors, shouldShowFallbackLogos } = getEventTeamLogos(event);

    const scoreboardProps = useScoreboard(event, 'card');
    const gameTrackerConfig = useGameTrackerConfig(event.league, event.event_details);

    return (
        <>
            <ScoreBoardAccordion
                scoreboardProps={scoreboardProps}
                teamLogos={teamLogos}
                eventTitle={eventTitle}
                eventStatus={eventStatus}
                teamFallbackTextColors={teamFallbackTextColors}
                shouldShowFallbackLogos={shouldShowFallbackLogos}
                gameTrackerConfig={gameTrackerConfig}
                showGameTrackerTooltip={showGameTrackerTooltip}
                screenName={'SBK_BetDetailScreen_GameTrackerTooltip'}
            />
            <BetSelectionList event={event} isLastEvent={isLastEvent} variant="l" />
        </>
    );
};
